import { common } from "./common";
import homeHtml from "./home.html" with { type: "text" };
import naudotosHtml from "./naudotos.html" with { type: "text" };
import montavimasHtml from "./montavimas.html" with { type: "text" };
import ratlankiaiHtml from "./ratlankiai.html" with { type: "text" };
import type { SiteContent } from "../types";

export const lt: SiteContent = { common, homeHtml, naudotosHtml, montavimasHtml, ratlankiaiHtml };
